var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, IconButton, Table, Timestamp } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { PureComponent } from 'react';
import { analytics } from 'app/utils/segment';
import styles from '../../templates.module.scss';
import { TemplateLanguagesCell } from './templateLanguagesCell/templateLanguagesCell';
export class TemplatesTableRow extends PureComponent {
    openEditModal() {
        const { templatesOpenAddModal, template, templateType } = this.props;
        analytics.settingsTemplatesEditTemplateButtonClicked({
            templateType,
            templateName: template.name,
        });
        templatesOpenAddModal(template);
    }
    openRemoveModal() {
        const { templatesOpenRemoveModal, template, templateType } = this.props;
        analytics.settingsTemplatesRemoveTemplateButtonClicked({
            templateType,
            templateName: template.name,
        });
        templatesOpenRemoveModal(template);
    }
    render() {
        const { template, hasLanguageTranslationControlFF } = this.props;
        return (_jsxs(Table.Tr, { children: [_jsx(Table.Td, { children: template.name }), _jsx(Table.Td, { children: _jsx(Timestamp, { relative: true, time: template.created_at }) }), _jsx(Table.Td, { children: template.last_edited_at ? (_jsx(Timestamp, { relative: true, time: template.last_edited_at })) : ('-') }), hasLanguageTranslationControlFF && (_jsx(Table.Td, { children: _jsx(TemplateLanguagesCell, { translations: template.translations }) })), _jsx(Table.Td, { children: _jsxs(FlexBox, Object.assign({ alignItems: "center" }, { children: [_jsx(IconButton, { variant: "tertiary", icon: "pen", className: styles.editButton, onClick: this.openEditModal }), _jsx(IconButton, { variant: "tertiary", icon: "trash", onClick: this.openRemoveModal })] })) })] }));
    }
}
__decorate([
    boundMethod
], TemplatesTableRow.prototype, "openEditModal", null);
__decorate([
    boundMethod
], TemplatesTableRow.prototype, "openRemoveModal", null);
